export enum DynamicLinkType {
    Home,
    Detail
}

export enum Platform {
    Hibrary,
    CuElibrary
}